import Swal from "sweetalert2";
import { getService } from "../../../../function/helper";

const payment = async ({ values, loading }) => {
  loading(true);
  const response = await getService("/external-post/v1/payment/request", {
    numberParcel: values.numberParcel,
  });

  if (response.status === 200) {
    window.location.replace(`${response.data.path}`);
    return;
  }

  loading(false);
  Swal.fire({
    icon: "error",
    text: response.message,
    showConfirmButton: false,
  });
};

export default payment;
